import { useSelector } from 'react-redux';
import { selectCategories } from './retentionDecisions';

export const useHasRetainableItems = (): boolean => {
    return useSelector((state: unknown) => selectCategories(state).length > 0);
};
